<template>
    <transition name="slide-fade">
        <div class="pop-box pop-booth">
            <router-link :to="productId ? `/product/${ productCate }` : '/'" class="btn-back"><i class="remixicon-arrow-left-s-line"></i>返回</router-link>
            <div class="cnt">
                <div class="title">{{ title }}</div>
                <div class="detail">
                    <div class="scroll">
                        <template v-for="(item, index) in detail">
                            <img v-if="item.img" :src="require(`@/assets/images/${ item.img }`)" />
                            <p v-if="item.p" v-html="item.p"></p>
                        </template>
                    </div>
                </div>
            </div>

            <!-- <div v-if="link && link.indexOf('#') == 0"><div class="btn-more" v-scroll-to="{ el: link }" @click="clickDetail"><i class="remixicon-add-line"></i>更多详情{{ link }}</div></div> -->
            <div v-if="link && link.indexOf('#') == 0"><div class="btn-more" @click="clickDetail(link)"><i class="remixicon-add-line"></i>更多详情</div></div>
            <a :href="link" target="_blank" v-else-if="link" class="btn-more"><i class="remixicon-add-line"></i>更多详情</a>

        </div>
    </transition>
</template>

<script>
import boothData from '@/data/booth.js'
import productData from '@/data/product.js'
import scheduleData from '@/data/schedule.js'
import Bus from '@/eventbus.js'

export default {
    name: 'PopBox',
    data() {
        return {
            section: '',
            productCate: '',
            id: '',
            data: [],
            title: '',
            subtitle: '',
            artist: '',
            detail: [],
            link: '',
            productId: 0,
            boothId: 0
        }
    },
    methods: {
        initData() {
            const { boothId, productCate, productId, scheduleId } = this.$route.params
            if (boothId) {
                const booth = boothData.find((item, index) => item.id == (+boothId))
                const { title, subtitle, artist, detail, link } = booth
                this.title = title
                this.subtitle = subtitle
                this.artist = artist
                this.detail = detail
                this.link = link
                this.boothId = boothId
                return
            }
            if (scheduleId) {
                const { title, detail, link } = scheduleData.find((item, index) => item.id == (+scheduleId))
                this.title = title
                this.detail = detail
                this.link = link
                return
            }

            if (productId) {
                const product = productData.find((item, index) => item.category == productCate && item.id == (+productId))
                const { title, subtitle, artist, detail, link } = product
                this.title = title
                this.subtitle = subtitle
                this.artist = artist
                this.detail = detail
                this.link = link
                this.productId = productId
                this.productCate = productCate
                return
            }
        },
        clickDetail(link) {
            setTimeout(() => this.$scrollTo(link), 200)
            this.$router.push('/')
        }
    },
    created() {
        this.initData()
    },
    activated() {
        setTimeout(() => Bus.$emit('switchBox', true), 100)
    },
    deactivated() {
        
    },
    watch: {
        '$route' (to, from) {
            this.productId = 0
            this.boothData = 0
            this.scheduleId = 0
            this.initData()
            if (to.path === '/') {
                setTimeout(() => Bus.$emit('switchBox', false), 100)
            }
        }
    }
}
</script>

<style lang="scss">

</style>